import React from 'react';
import Layout from '@components/layout';
import WeAre from '@components/we-are';
import Intro from '@components/intro';
import BannerCta from '@components/banner/BannerCta';
import ProductFeatures from '@components/product-features';
import LocationDetails from '@components/location-details';
import CarouselQuote from '@components/carousel-quote';

const Nearshore = (props) => {
	const { location, pageContext } = props;
	const { locations } = pageContext;

	return (
		<Layout location={location} pageContext={pageContext}>
			<WeAre
				{...pageContext['we-are']}
				intro={true}
				illustrations={'/cms/assets/nearshore-illustration.svg'}
				h1Title
				imageAlt={'Nearshore Software Development | Uruit'}
			/>
			<Intro {...pageContext.intro} h2Title hasWhiteBackground />
			<Intro {...pageContext['high-performing-teams']} />
			<ProductFeatures {...pageContext['product-features']} bullets={true} />
			{locations && locations.length && locations.map((location, i) => <LocationDetails key={i} {...location} />)}
			<CarouselQuote {...pageContext['reviews']} />
			<BannerCta smallContainer={true} title="Like what you see?" link="/contact" cta="Let's talk!" />
		</Layout>
	);
};

export default Nearshore;
